import Swal from 'sweetalert2'
import { lang } from '../../assets/lang'
import { actionButtonHtml } from './actionButtonHtml'

import {
  makeAjaxCall,
  sweetAlertCommonParams,
  selectedOptionsTextArray,
} from '../../utils/functions'

const base_url = window.xitFlowBuilderData.base_url
const page_table_id = window.xitFlowBuilderData.page_table_id
const builder_table_id = window.xitFlowBuilderData.builder_table_id
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
const has_action_buttons = window.xitFlowBuilderData.has_action_buttons

let isFilesAddedToHead = false

const defaultCheckboxPluginColors = {
  bgColor: '#5CB85C',
  textColor: '#FFFFFF',
  hoverBgColor: '#339966',
  hoverTextColor: '#FFFDDD',
}

const defaultSendToMessageColors = {
  bgColor: '#5CB85C',
  textColor: '#FFFFFF',
  hoverBgColor: '#339966',
  hoverTextColor: '#FFFDDD',
}

const defaultMeLinkColors = {
  bgColor: '#0084FF',
  textColor: '#FFFFFF',
  hoverBgColor: '#367FA9',
  hoverTextColor: '#FFFDDD',
}

// eslint-disable-next-line
export const actionButtonModal = async (oldData, node, defaultData) => {
  const commonParams = sweetAlertCommonParams(node, '22rem')
  
  return await Swal.fire({
    ...commonParams,
    title: lang.action_button_modal_title,
    html: actionButtonHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      if (false === isFilesAddedToHead) {
        /** Loads lazily bootstrap-colorpicker script */
        $('head').append('<script src="https://cdn.jsdelivr.net/npm/bootstrap-colorpicker@3.4.0/dist/js/bootstrap-colorpicker.min.js"></script>')
        $('head').append('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-colorpicker@3.4.0/dist/css/bootstrap-colorpicker.min.css">')

        isFilesAddedToHead = true
      }

      /** Handles action buttons list section */
      const actionButtonElement = $('#action-button-actions')
      const messengerEngagementPluginsListGroupEelement = $('#action-button-messenger-engagement-plugins-list-group')
      const messengerEngagementPluginsGroupElement = $('#action-button-messenger-engagement-plugins-group')
      const messengerEngagementPluginsListElement = $('#action-button-messenger-engagement-plugins-list')
      
      const redirectionStatusElement = $("#redirection-status")
      const optinSuccessMessageWrapperElement = $('.opt-in-success-message-wrapper')
      const addingButtonInSuccessMessageElement = $('#adding-button-in-success-message')
      const redirectionUrlForSuccessfulOptin = $('#redirection-url-for-successful-optin')
      const buttonAttributeElement = $('.button-attribute')
      const optinSuccessRedirectUrlElement = $('#optin-success-redirect-url')
  
      const checkboxPluginElement = $('.checkbox-plugin') 
      const sendToMessengerElement = $('.send-to-messenger')
      const mMeLinkElement = $('.m-me-link') 
      const customerChatPlugin = $('.customer-chat-plugin')

      /** Fill in oldData if there is any */
      const oldSelectedActionButton = oldData.actionType 
        || ((defaultData && defaultData.selectedAction) 
          ? defaultData.selectedAction
          : '')
      const oldSelectedPlugin = oldData.pluginType 
        || ((defaultData && defaultData.selectedPlugin) 
          ? defaultData.selectedPlugin
          : '')
      
      actionButtonElement.val(oldSelectedActionButton || '').trigger('change')
      messengerEngagementPluginsListElement.val(oldSelectedPlugin || '').trigger('change')

      $('#domain-name').val(oldData.domain || '')
      $('#action-button-messenger-engagement-languages').val(oldData.language || 'en_US').trigger('change')
      $('#action-button-messenger-engagement-cta-button-texts').val(oldData.ctaButtonType || '').trigger('change')
      
      if ('messenger_engagement_plugin' === oldData.actionType && 'checkbox_plugin' === oldData.pluginType) {
        if (oldData.pluginSkin) {
          $('input[name="checkbox-plugin-skin"][value="' + oldData.pluginSkin + '"]').prop('checked', true)
        }

        $('input[name="center-align"][value="' + oldData.pluginCenterAlign + '"]').prop('checked', true)
        
        if (oldData.pluginSize) {
          $('input[name="checkbox-plugin-size"][value="' + oldData.pluginSize + '"]').prop('checked', true)
        }
      }
      
      if ('messenger_engagement_plugin' === oldData.actionType && 'send_to_messenger' === oldData.pluginType) {
        if (oldData.pluginSkin) {
          $('input[name="send-to-messenger-plugin-skin"][value="' + oldData.pluginSkin + '"]').prop('checked', true)
        }

        $('input[name="center-align"][value="' + oldData.pluginCenterAlign + '"]').prop('checked', true)

        if (oldData.pluginSize) {
          $('input[name="send-to-messenger-plugin-size"][value="' + oldData.pluginSize + '"]').prop('checked', true)
        }
      }

      $("#redirection-status").prop('checked', ('1' === oldData.redirectionStatus) ? true : false)

      if (oldData.optInSuccessMessage) {
        $('#opt-in-success-message').val(oldData.optInSuccessMessage)
      }

      $('#adding-button-in-success-message').prop('checked', ('1' === oldData.addingButtonInSuccessMessage) ? true : false)

      $('#button-text').val(oldData.buttonText || 'Send Message')
      $('#button-url').val(oldData.buttonUrl || '')

      $('#button-bg-color').val(oldData.buttonBgColor || '')
      $('#button-text-color').val(oldData.buttonTextColor || '')
      $('#button-hover-bg-color').val(oldData.buttonHoverBgColor || '')
      $('#button-hover-text-color').val(oldData.buttonHoverTextColor || '')

      $('input[name="button-size"][value="' + oldData.buttonSize + '"]').prop('checked', true)

      redirectionUrlForSuccessfulOptin.val(oldData.redirectionUrlForSuccessfulOptin || '')
      $('#checkbox-validation-error-message').val(oldData.checkboxValidationErrorMessage || '')
      $('input[name="chat-plugin-loading-status"][value="' + oldData.chatPluginLoadingStatus + '"]').prop('checked', true)
      $('#chat-plugin-loading-delay-in-seconds').val(oldData.chatPluginLoadingDelayInSeconds || '')
      $('#theme-color').val(oldData.chatPluginThemeColor || '#FFFFFF')

      $('input[name="hide-chat-plugin-if-not-logged-in"][value="' + oldData.hideChatPluginIfNotLoggedIn + '"]').prop('checked', true)
      $('#greeting-text-if-logged-in').val(oldData.greetingTextIfLoggedIn || '')
      $('#greeting-text-if-not-logged-in').val(oldData.greetingTextIfNotLoggedIn || '')

      $('#reference').val(oldData.reference || '')

      function toggleActionButtonsList(selectedActionButton) {
        if ('messenger_engagement_plugin' === selectedActionButton) {
          messengerEngagementPluginsListGroupEelement
            .add(messengerEngagementPluginsGroupElement)
            .removeClass('d-none').addClass('d-block')

          const selectedMessengerEngagementPlugin = messengerEngagementPluginsListElement.val()
          toggleMessengerEngagementPluginsList(selectedMessengerEngagementPlugin, oldData)

        } else {
          messengerEngagementPluginsListGroupEelement
            .add(messengerEngagementPluginsGroupElement)
            .removeClass('d-block').addClass('d-none')
        }
      }

      function toggleMessengerEngagementPluginsList(selectedMessengerEngagementPlugin, oldData) {
        messengerEngagementPluginsGroupElement.removeClass('d-none').addClass('d-block')
        
        if ('checkbox_plugin' === selectedMessengerEngagementPlugin) {
          sendToMessengerElement
            .add(mMeLinkElement)
            .add(customerChatPlugin)
            .removeClass('d-block').addClass('d-none')

          if (addingButtonInSuccessMessageElement.prop('checked')) {
            setColorDependingOnMessengerEngagementPlugin(oldData)
          } else {
            buttonAttributeElement.removeClass('d-block').addClass('d-none')
          }

          checkboxPluginElement.removeClass('d-none').addClass('d-block')
          
          const redirectionStatus = redirectionStatusElement.prop('checked')
          toggleRedirectionStatusOnSuccessfulOptin(redirectionStatus, oldData)
        } else if('send_to_messenger' === selectedMessengerEngagementPlugin) {
          checkboxPluginElement
            .add(mMeLinkElement)
            .add(customerChatPlugin)
            .removeClass('d-block').addClass('d-none')
          
          if (addingButtonInSuccessMessageElement.prop('checked')) {
            setColorDependingOnMessengerEngagementPlugin(oldData)
          } else {
            buttonAttributeElement.removeClass('d-block').addClass('d-none')
          }

          sendToMessengerElement.removeClass('d-none').addClass('d-block')

          const redirectionStatus = redirectionStatusElement.prop('checked')
          toggleRedirectionStatusOnSuccessfulOptin(redirectionStatus, oldData)
        } else if ('m_me_link' === selectedMessengerEngagementPlugin) {
          checkboxPluginElement
            .add(sendToMessengerElement)
            .add(customerChatPlugin)
            .removeClass('d-block').addClass('d-none')
          
          buttonAttributeElement.removeClass('d-none').addClass('d-block')
          $('.button-url').removeClass('d-block').addClass('d-none')
          setColorDependingOnMessengerEngagementPlugin(oldData)          

          mMeLinkElement.removeClass('d-none').addClass('d-block')
        } else if ('customer_chat_plugin' === selectedMessengerEngagementPlugin) { 
          checkboxPluginElement
            .add(sendToMessengerElement)
            .add(mMeLinkElement)
            .add(buttonAttributeElement)
            .removeClass('d-block').addClass('d-none')
          
          customerChatPlugin.removeClass('d-none').addClass('d-block')
        } else {
          messengerEngagementPluginsGroupElement.removeClass('d-block').addClass('d-none')
        }

        if (selectedMessengerEngagementPlugin) {
          const labelIdsData = {
            url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
            data: { 
              page_table_id, 
              requested_from: 'action_button', 
              instagram_bot_addon 
            },
          }

          makeAjaxCall(function(response) {
            const labelIdsElement = $("#label-ids")

            labelIdsElement.html(response.label_dropdown);
            labelIdsElement.val(oldData.labelIds || '').trigger('change')

            redirectionUrlForSuccessfulOptin.val(response.mme_link)
          }, labelIdsData)
        }
      }  

      function toggleRedirectionStatusOnSuccessfulOptin(redirectionStatus, oldData) {
        const selectedActionButton = actionButtonElement.val()
        const selectedMessengerEngagementPlugin = messengerEngagementPluginsListElement.val()

        if (redirectionStatus
          && 'messenger_engagement_plugin' === selectedActionButton 
          && ('checkbox_plugin' === selectedMessengerEngagementPlugin 
            || 'send_to_messenger' === selectedMessengerEngagementPlugin)
        ) {
          optinSuccessMessageWrapperElement
            .add(buttonAttributeElement)
            .removeClass('d-block').addClass('d-none')

          optinSuccessRedirectUrlElement.removeClass('d-none').addClass('d-block')
        } else {
          optinSuccessRedirectUrlElement.removeClass('d-block').addClass('d-none')
          optinSuccessMessageWrapperElement.removeClass('d-none').addClass('d-block')

          const isCheckedAddingButtonInSuccessMessage = addingButtonInSuccessMessageElement.prop('checked')
          toggleButtonAtrributes(isCheckedAddingButtonInSuccessMessage, oldData)
        }
      }

      function toggleButtonAtrributes(isCheckedAddingButtonInSuccessMessage, oldData) {
        const selectedActionButton = actionButtonElement.val()
        const selectedMessengerEngagementPlugin = messengerEngagementPluginsListElement.val()

        if (isCheckedAddingButtonInSuccessMessage
          && 'messenger_engagement_plugin' === selectedActionButton 
          && ('checkbox_plugin' === selectedMessengerEngagementPlugin 
            || 'send_to_messenger' === selectedMessengerEngagementPlugin)
        ) {
          buttonAttributeElement.removeClass('d-none').addClass('d-block')
          setColorDependingOnMessengerEngagementPlugin(oldData)
        } else {
          buttonAttributeElement.removeClass('d-block').addClass('d-none')
        }
      }

      /** Handles toggling messenger engagement plugins list */
      const selectedMessengerEngagementPlugin = messengerEngagementPluginsListElement.val()
      toggleMessengerEngagementPluginsList(selectedMessengerEngagementPlugin, oldData)

      messengerEngagementPluginsListElement.on('change', function() {
        toggleMessengerEngagementPluginsList(this.value, oldData)
      })

      /** Handles redirection on successful opt-in */
      const redirectionStatus = redirectionStatusElement.prop('checked')
      toggleRedirectionStatusOnSuccessfulOptin(redirectionStatus, oldData)

      redirectionStatusElement.on('change', function() {
        toggleRedirectionStatusOnSuccessfulOptin(this.checked, oldData)
      })

      /** Handles toggling button attributes */
      const isCheckedAddingButtonInSuccessMessage = addingButtonInSuccessMessageElement.prop('checked')
      toggleButtonAtrributes(isCheckedAddingButtonInSuccessMessage, oldData)
      
      addingButtonInSuccessMessageElement.on('change', function() {
        toggleButtonAtrributes(this.checked, oldData)
      })

      /** Handles toggling action buttons */
      const selectedActionButton = actionButtonElement.val()
      toggleActionButtonsList(selectedActionButton)

      actionButtonElement.on('change', function() {      
        toggleActionButtonsList(this.value)
      })

      setTimeout(function() {
        $('.color-picker-rgb').colorpicker({
          format: 'hex',
          popover: {
            placement: 'left'
          },
        })
      }, 1500)

      $('[data-toggle="tooltip"]').tooltip()
    },

    preConfirm: async () => {
      const actionType = $('#action-button-actions').val()
      const actionTypeText = $('#action-button-actions option:selected').text()

      const pluginType = $('#action-button-messenger-engagement-plugins-list').val()
      const pluginTypeText = $('#action-button-messenger-engagement-plugins-list option:selected').text()
      
      const domain = $('#domain-name').val()

      const language = $('#action-button-messenger-engagement-languages').val()
      const languageText = $('#action-button-messenger-engagement-languages option:selected').text()

      const ctaButtonType = $('#action-button-messenger-engagement-cta-button-texts').val()
      const ctaButtonTypeText = $('#action-button-messenger-engagement-cta-button-texts option:selected').text()

      let pluginSkin = $("input[name='checkbox-plugin-skin']:checked").val()
      
      if ('messenger_engagement_plugin' === actionType && 'send_to_messenger' === pluginType) {
        pluginSkin = $("input[name='send-to-messenger-plugin-skin']:checked").val()
      }

      const pluginCenterAlign = $("input[name='center-align']:checked").val()

      let pluginSize = $("input[name='checkbox-plugin-size']:checked").val()

      if ('messenger_engagement_plugin' === actionType && 'send_to_messenger' === pluginType) {
        pluginSize = $("input[name='send-to-messenger-plugin-size']:checked").val()
      }
      
      const redirectionStatus = $("#redirection-status").prop('checked')
      const optInSuccessMessage = $('#opt-in-success-message').val()
      const addingButtonInSuccessMessage = $('#adding-button-in-success-message').prop('checked')

      const buttonText = $('#button-text').val()
      const buttonUrl = $('#button-url').val()

      const buttonBgColor = $('#button-bg-color').val()
      const buttonTextColor = $('#button-text-color').val()
      const buttonHoverBgColor = $('#button-hover-bg-color').val()
      const buttonHoverTextColor = $('#button-hover-text-color').val()

      const buttonSize = $('input[name="button-size"]:checked').val()

      const redirectionUrlForSuccessfulOptin = $('#redirection-url-for-successful-optin').val()

      const checkboxValidationErrorMessage = $('#checkbox-validation-error-message').val()

      const chatPluginLoadingStatus = $('input[name="chat-plugin-loading-status"]:checked').val()
      const chatPluginLoadingDelayInSeconds = $('#chat-plugin-loading-delay-in-seconds').val()
      
      const chatPluginThemeColor = $('#theme-color').val()

      const hideChatPluginIfNotLoggedIn = $('input[name="hide-chat-plugin-if-not-logged-in"]:checked').val()

      const greetingTextIfLoggedIn = $('#greeting-text-if-logged-in').val()
      const greetingTextIfNotLoggedIn = $('#greeting-text-if-not-logged-in').val()

      const reference = $('#reference').val()

      const labelIds = $('#label-ids').val()
      const labelIdsTexts = $('#label-ids option:selected')
      const labelIdTextsArray = selectedOptionsTextArray(labelIdsTexts)

      if (! actionType) {
        Swal.showValidationMessage(lang.action_button_modal_msg_action_type)
        return;
      }

      if (('messenger_engagement_plugin' !== actionType) && (has_action_buttons || window.xitFlowBuilderData.has_action_buttons)) {
        Swal.showValidationMessage(lang.action_button_modal_msg_has_action_buttons)
        return;
      }

      if ('messenger_engagement_plugin' === actionType) {
        if (! pluginType) {
          Swal.showValidationMessage(lang.action_button_modal_msg_plugin_type)
          return
        }

        if ('checkbox_plugin' === pluginType || 'send_to_messenger' === pluginType) {
          if (! domain) {
            Swal.showValidationMessage(lang.action_button_modal_msg_domain)
            return
          } 
          
          if (! language) {
            Swal.showValidationMessage(lang.action_button_modal_msg_language)
            return
          }

          if (! pluginSkin) {
            Swal.showValidationMessage(lang.action_button_modal_msg_plugin_skin)
            return
          } 
          
          if (! pluginSize) {
            Swal.showValidationMessage(lang.action_button_modal_msg_plugin_size)
            return
          }
          
          if (redirectionStatus) {
            if (! redirectionUrlForSuccessfulOptin) {
              Swal.showValidationMessage(lang.action_button_modal_msg_plugin_redirection_status)
              return
            }
          }
          
          if (addingButtonInSuccessMessage) {
            if (! buttonText) {
              Swal.showValidationMessage(lang.action_button_modal_msg_button_text)
              return
            }

            if (! buttonUrl) {
              Swal.showValidationMessage(lang.action_button_modal_msg_button_url)
              return
            }
      
            if (! buttonBgColor 
              || ! buttonTextColor 
              || ! buttonHoverBgColor 
              || ! buttonHoverTextColor
            ) {
              Swal.showValidationMessage(lang.action_button_modal_msg_button_attributes)
              return
            }
          }
        }
        
        if ('checkbox_plugin' === pluginType) {
          if (! pluginCenterAlign) {
            Swal.showValidationMessage(lang.action_button_modal_msg_plugin_center_align)
            return
          } 
        }

        if ('m_me_link' === pluginType) {
          if (! buttonText) {
            Swal.showValidationMessage(lang.action_button_modal_msg_button_text)
            return
          }

          if (! buttonSize) {
            Swal.showValidationMessage(lang.action_button_modal_msg_button_size)
            return
          }

          if (! buttonBgColor 
            || ! buttonTextColor 
            || ! buttonHoverBgColor 
            || ! buttonHoverTextColor
          ) {
            Swal.showValidationMessage(lang.action_button_modal_msg_button_attributes)
            return
          }
        } 

        if ('customer_chat_plugin' === pluginType) {
          if (! domain) {
            Swal.showValidationMessage(lang.action_button_modal_msg_domain)
            return
          } 
          
          if (! language) {
            Swal.showValidationMessage(lang.action_button_modal_msg_language)
            return
          }
          
          if (! chatPluginLoadingStatus) {
            Swal.showValidationMessage(lang.action_button_modal_msg_chat_plugin_loading_status)
            return
          }

          if(! chatPluginThemeColor) {
            Swal.showValidationMessage(lang.action_button_modal_msg_chat_plugin_theme_color)
            return
          }
        }
        
        if (! reference) {
          Swal.showValidationMessage(lang.action_button_modal_msg_reference)
          return
        }

        const result = await fetch(base_url + 'visual_flow_builder/check_field_value_exists/' + builder_table_id + '/' + pluginType + '/' + reference)
          .then(function(response) {
            return response.json()
          })

        if (false === result.status) {
          Swal.showValidationMessage(result.message)
          return
        }
      }

      return {
        actionType,
        actionTypeText,
        
        pluginType,
        pluginTypeText,
        
        domain,
        
        language,
        languageText,
        
        ctaButtonType,
        ctaButtonTypeText,

        pluginSkin,
        pluginCenterAlign,
        pluginSize,

        redirectionStatus: (true === redirectionStatus) ? '1' : '0',

        optInSuccessMessage,
        addingButtonInSuccessMessage: (true === addingButtonInSuccessMessage) ? '1' : '0',

        buttonText,
        buttonUrl,

        buttonBgColor,
        buttonTextColor,
        buttonHoverBgColor,
        buttonHoverTextColor,

        buttonSize,

        redirectionUrlForSuccessfulOptin,

        checkboxValidationErrorMessage,

        chatPluginLoadingStatus,

        chatPluginLoadingDelayInSeconds,

        chatPluginThemeColor,

        hideChatPluginIfNotLoggedIn,

        greetingTextIfLoggedIn,
        greetingTextIfNotLoggedIn,

        reference,
        
        labelIds,
        labelIdTextsArray,
      }
    },    
  })
}

const setColorDependingOnMessengerEngagementPlugin = (oldData) => {
  const actionButtonElement = $('#action-button-actions')
  const selectedActionButton = actionButtonElement.val()

  const messengerEngagementPluginsListElement = $('#action-button-messenger-engagement-plugins-list')
  const selectedMessengerEngagementPlugin = messengerEngagementPluginsListElement.val()

  const buttonBgColor = $('#button-bg-color')
  const buttonTextColor = $('#button-text-color')
  const buttonHoverBgColor = $('#button-hover-bg-color')
  const buttonHoverTextColor = $('#button-hover-text-color')

  if ('messenger_engagement_plugin' === selectedActionButton
    && 'checkbox_plugin' === selectedMessengerEngagementPlugin
  ) {
    buttonBgColor.val(oldData.buttonBgColor || defaultCheckboxPluginColors.bgColor)
    buttonBgColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonBgColor || defaultCheckboxPluginColors.bgColor)

    buttonTextColor.val(oldData.buttonTextColor || defaultCheckboxPluginColors.textColor)
    buttonTextColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonTextColor || defaultCheckboxPluginColors.textColor)
    
    buttonHoverBgColor.val(oldData.buttonHoverBgColor || defaultCheckboxPluginColors.hoverBgColor)
    buttonHoverBgColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonHoverBgColor || defaultCheckboxPluginColors.hoverBgColor)
    
    buttonHoverTextColor.val(oldData.buttonHoverTextColor || defaultCheckboxPluginColors.hoverTextColor)
    buttonHoverTextColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonHoverTextColor || defaultCheckboxPluginColors.hoverTextColor)
  } else if ('messenger_engagement_plugin' === selectedActionButton
    && 'send_to_messenger' === selectedMessengerEngagementPlugin
  ) {
    buttonBgColor.val(oldData.buttonBgColor || defaultSendToMessageColors.bgColor)
    buttonBgColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonBgColor || defaultSendToMessageColors.bgColor)

    buttonTextColor.val(oldData.buttonTextColor || defaultSendToMessageColors.textColor)
    buttonTextColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonTextColor || defaultSendToMessageColors.textColor)
    
    buttonHoverBgColor.val(oldData.buttonHoverBgColor || defaultSendToMessageColors.hoverBgColor)
    buttonHoverBgColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonHoverBgColor || defaultSendToMessageColors.hoverBgColor)
    
    buttonHoverTextColor.val(oldData.buttonHoverTextColor || defaultSendToMessageColors.hoverTextColor)
    buttonHoverTextColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonHoverTextColor || defaultSendToMessageColors.hoverTextColor)
  } else if ('messenger_engagement_plugin' === selectedActionButton
    && 'm_me_link' === selectedMessengerEngagementPlugin
  ) {
    buttonBgColor.val(oldData.buttonBgColor || defaultMeLinkColors.bgColor)
    buttonBgColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonBgColor || defaultMeLinkColors.bgColor)

    buttonTextColor.val(oldData.buttonTextColor || defaultMeLinkColors.textColor)
    buttonTextColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonTextColor || defaultMeLinkColors.textColor)
    
    buttonHoverBgColor.val(oldData.buttonHoverBgColor || defaultMeLinkColors.hoverBgColor)
    buttonHoverBgColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonHoverBgColor || defaultMeLinkColors.hoverBgColor)
    
    buttonHoverTextColor.val(oldData.buttonHoverTextColor || defaultMeLinkColors.hoverTextColor)
    buttonHoverTextColor.next().find('.colorpicker-input-addon i').css('background-color', oldData.buttonHoverTextColor || defaultMeLinkColors.hoverTextColor)
  }
}